import { t } from "i18next";

export const formatDate = (dateString: string) => {
  const date = new Date(dateString);
  const day = date.getDate();
  const month = date.getMonth() + 1;
  const year = date.getFullYear();
  return `${day < 10 ? "0" + day : day}.${
    month < 10 ? "0" + month : month
  }.${year}`;
};

export const formatPrice = (price: number) => {
  if (price) {
    return price
      .toFixed(2)
      .replace(".", ",")
      .replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  }
  return "0,00";
};

export const removeTrailingZeros = (input: string) => {
  let result = input.replace(/\.?0+$/, "");

  if (result.endsWith(",")) {
    result = result.slice(0, -1);
  }

  return result;
};

export const monthString = (month: number) => {
  switch (month) {
    case 1:
      return t("common.january");
    case 2:
      return t("common.february");
    case 3:
      return t("common.march");
    case 4:
      return t("common.april");
    case 5:
      return t("common.may");
    case 6:
      return t("common.june");
    case 7:
      return t("common.july");
    case 8:
      return t("common.august");
    case 9:
      return t("common.september");
    case 10:
      return t("common.october");
    case 11:
      return t("common.november");
    case 12:
      return t("common.december");
    default:
      return "";
  }
};
